<template>
  <main class="content content_inner">
    <div class="page-wrapper page-wrapper_inner">
      <RouterLink to="/" class="back-link">
        <app-svg class="back-link__icon" icon="left" width="24" height="24" />
        To homepage
      </RouterLink>

      <h2 class="h2 h2_inner">Privacy Policy</h2>

      <pre class="text privacy-text">
Soda Connect (“App”) does not collect personal data.
The App is designed to operate with minimal user information and without tracking user activity.
The App is a mobile utility that provides network connections using the encrypted VLESS protocol.
We are committed to protecting user privacy and apply a data minimization principle, meaning we only process information that is strictly necessary for the app to function.
Soda Connect does not collect or store personal data.
The App does not create user profiles and does not track user behavior.
Soda Connect works by establishing a secure connection between your device and a server specified by your VLESS key.
All network traffic is routed directly between the user and the selected server.
We do not intermediate, inspect, log, or store this traffic.

The App may display local traffic statistics (such as session duration or data usage) directly on your device for informational purposes. This information:
- is processed locally on the device,
- is not transmitted to us,
- is not stored on our servers.

Soda Connect:
- does not collect device identifiers,
- does not collect device model, OS version, or hardware information,
- does not use analytics or crash-reporting tools that transmit user data to third parties.

We do not sell, share, rent, or disclose any user data to third parties.
Soda Connect is provider-independent and does not control or manage third-party servers.
Soda Connect is a software utility and does not require a license to operate as an application.
Users are responsible for ensuring that their use of the App complies with applicable local laws and regulations.
Soda Connect does not sell or share personal information, no personal data is collected or processed.
We may update this Privacy Policy from time to time to ensure it remains accurate and transparent.

Any changes will be reflected on this page.
Continued use of the App constitutes acceptance of the updated policy.

If you have questions regarding this Privacy Policy, please contact us to email: <a href="mailto:hello@sodaconnect.app">hello@sodaconnect.app</a>
</pre>
    </div>
  </main>
</template>
